module.exports = __webpack_public_path__ + "img/37917-064.2308e018.jpg";